<template>
  <div style="background:#fff;">
    <div class="search-box">
      <div class="search-img"></div>
      <input type="text" placeholder="输入医生 、疾病搜索" @click="routePush('/search')" />
    </div>
    <div class="doc-list find-doc">
      <div class="doc-filter border-rad">
        <div
          class="display_flex_start"
          :class="{'active':filter_index == item.key}"
          v-for="(item,index) in filter_list"
          @click="handleFilter(item.key,index)"
          :key="index"
        >
          {{item.name}}
          <img
            class="filter-img"
            :src="filter_index == item.key?filter_img1:filter_img0"
          />
        </div>
      </div>
      <loadMore v-if="docList.length>0" :onLoadMore="onLoadMore" :enableLoadMore="enableLoadMore">
        <ul class="hot-lists">
          <li
            class="zhuanjia-card"
            v-for="(item,index) in docList"
            :key="index"
            :class="{'li-end':index == docList.length-1}"
          >
            <div class="zhuanjia-card-info" @click.stop="$router.push('/doctor_main?doctorid='+item.id)">
              <div class="zhuanjia-text">
                <h3>{{item.zname}}</h3>
                <p>{{item.position}}</p>
                <p>{{item.hospname}}</p>
                <div class="zhuanjia-tags">
                  <span v-for="(items,index) in item.label_list" :key="index" v-if="index<3">{{items}}</span>
                </div>
              </div>
              <div class="zhuanjia-img">
                <img :src="item.cover_image" alt="">
              </div>
              <div class="my-zhuanjia" v-if="item.type == 3">我的医生</div>
            </div>
            <div class="zhuanjia-goodbe" @click.stop="$router.push('/doctor_main?doctorid='+item.id)">
              擅长:{{item.goodable}}
            </div>
            <div class="servies-box">
              <div class="servies-item ser-tuwen" :class="{'is_close':item.is_graphic == 1}" @click.stop="item.is_graphic == 0?$router.push('/wenzhen_order_pay?type=1&doctorid='+item.id):$toast.center('图文问诊暂未开通')">
                <p>图文问诊</p>
                <span v-if="item.is_graphic == 0">￥{{item.graphic_money/100}}</span>
                <span v-else>即将开通</span>
              </div>
              <div class="servies-item ser-dianhua" :class="{'is_close':item.is_phone == 1}" @click.stop="item.is_phone==0?$router.push('/wenzhen_order_pay?type=2&doctorid='+item.id):$toast.center('电话问诊暂未开通')">
                <p>电话问诊</p>
                <span v-if="item.is_phone == 0">￥{{item.phone_money/100}}</span>
                <span v-else>即将开通</span>
              </div>
              <div class="servies-item ser-shipin is_close" @click="$toast.center('视频问诊暂未开通')">
                <p>视频问诊</p>
                <span>即将开通</span>
              </div>
              <!--<div class="servies-item ser-shipin" :class="{'is_close':item.is_video == 1}" @click.stop="item.is_video==0?$router.push('/shipin_order_pay?&doctorid='+item.id):$toast.center('视频问诊暂未开通')">
                <p>视频问诊</p>
                <span v-if="item.is_video == 0">￥{{item.video_money/100}}</span>
                <span v-else>未开通</span>
              </div>-->

            </div>
            <!-- <div class="dis-doc-left">
              <div class="item-expert">
                <p class="expert-avar">
                  <img :src="item.avatar" class="all-i" alt />
                </p>
                <i class="icon icon-jiav"></i>
              </div>
            </div>
            <div class="expert-info">
              <div class="item-expert font-85">
                <div class="expert-info-doctor display_flex_start">
                  <span class="expert-name">{{item.zname}}</span>
                  <span class="expert-pos">{{item.position}}</span>
                  <div
                    class="doc-save"
                    @click="handleToFav(item.id,item.type,index)"
                    v-if="item.type !=3"
                  >
                    <img :src="item.type == 1?img_src:img_src1" alt />
                  </div>
                  <div class="doc-save" v-if="item.type ==3">问诊过</div>
                </div>
                <p class="expert-info-good">{{item.hospname}}</p>
              </div>
              <div class="item-dis good-hide">擅长：{{item.goodable}}</div>
              <div class="doc-label-list display_flex_start" v-if="item.label">
                <div
                  class="doc-label display_flex_start"
                  v-for="(label_item,label_index) in item.label_list"
                  v-show="label_index<3"
                  :key="label_index"
                >{{label_item}}</div>
              </div>
              <div class="doc-btns display_flex_start font-85">
                <i class="icon icon-guahao"></i>在线问诊
                <span class="doc-price">￥{{item.graphic_money}}起</span>
              </div>
            </div> -->
          </li>
        </ul>
      </loadMore>
      <div class="doc-default" v-if="docList.length==0">
        <img src="../../../static/icons/shuju@3x.jpg" alt />
        <div class="doc-default-txt font-85">暂无数据</div>
      </div>
      <div
        class="filter-box"
        v-if="filter_index && filter_option[filter_index].length>0 && is_filter"
      >
        <div
          v-if="filter_index!='job'"
          class="filter-option"
          :class="{'filter-active':item.checked}"
          v-for="(item,index) in filter_option[filter_index]"
          :key="index"
          @click="handleFilterClick(index)"
        >{{item.name}}</div>
        <div
          class="filter-job-option"
          v-if="filter_index == 'job'"
          :class="{'filter-active':item.checked}"
          v-for="(item,index) in filter_option[filter_index]"
          :key="index"
          @click="handleFilterClick(index)"
        >
          {{item.name}}
          <img v-if="item.checked" src="../../../static/icons/addac@3x.png" alt />
        </div>
      </div>
      <div class="doc-mask" v-if="is_filter"></div>
    </div>
    <!-- <tabbar/> -->
  </div>
</template>
<script>
import http from "../../request/http";
import tabbar from "../../components/tabbar/tabbar";
import loadMore from "../loadMore";
export default {
  name: "find_doctor",
  data() {
    return {
      enableLoadMore: true,
      disId: "",
      docpos: "",
      docservice: "",
      is_search: false,
      img_src: "../../../static/icons/guanzhu_false@3x.png",
      img_src1: "../../../static/icons/guanzhu_true@3x.png",
      filter_list: [
        { key: "distab", name: "疾病" },
        { key: "job", name: "职称" },
        { key: "service", name: "服务" },
      ],
      filter_index: "",
      filter_img0: "../../../static/icons/arrow_bottom.png",
      filter_img1: "../../../static/icons/arrow_bottom@3x.png",
      filter_option: {
        distab: [],
        job: [
          { id: 1, name: "主任医师", checked: false },
          { id: 2, name: "副主任医师", checked: false },
          { id: 3, name: "主治医师", checked: false },
          { id: 4, name: "住院医师", checked: false },
        ],
        service: [
          { id: 1, name: "图文咨询", checked: false },
          { id: 2, name: "电话咨询", checked: false },
        ],
      },
      is_filter: false,
      page: 1,
      doc_list: [],
      filter_list_index:-1
    };
  },
  components: {
    tabbar,
    loadMore,
  },
  computed: {
    docList() {
      return this.$store.state.find_doc_list;
    },
  },
  mounted() {
    this.getDistab();
    this.Doctorlist();
  },
  methods: {
    onLoadMore(done) {
      setTimeout(() => {
        if (!this.enableLoadMore) {
          return;
        }
        this.page = this.page + 1;
        this.Doctorlist(() => {
          done();
        });
      }, 200);
    },
    // 关注
    handleToFav(id, type, index) {
      let data = {
        docid: id,
        fan_tag: +type,
      };
      http.post("/api/wap/doctor/fan", data).then((res) => {
        if (res.errno == 0) {
          this.docList.forEach((v, i) => {
            if (i == index) {
              v.type = type == 1 ? 2 : 1;
            }
          });
        }
      });
    },
    // 过滤
    handleFilterClick(index) {
      this.filter_option[this.filter_index].forEach((v, i) => {
        if (i == index) {
          v.checked = true;
          if(this.filter_list_index != -1){
            this.filter_list[this.filter_list_index].name = v.name;
          }
        } else {
          v.checked = false;
        }
      });
      this.is_filter = false;
      this.page = 1;
      this.Doctorlist();
    },
    // 过滤tab切换
    handleFilter(index,i) {
      this.filter_list_index = i;
      if (index != this.filter_index) {
        this.is_filter = true;
      } else {
        this.is_filter = !this.is_filter;
      }
      this.filter_index = index;
    },
    // 疾病列表
    getDistab() {
      http.post("/api/wap/public/distab", {}).then((res) => {
        if (res.data && res.data.length) {
          res.data.forEach((v) => {
            if(v.id  == this.$route.query.disid){
              v.checked = true;
              this.filter_index = "distab"
              this.filter_list[0].name = v.name
              this.disId = v.id
              this.Doctorlist();
            }else{
              v.checked = false;
            }
          });
          this.filter_option.distab = res.data;
        } else {
          this.filter_option.distab = [];
        }
      });
    },
    // 找名医列表
    Doctorlist(done = function () {}) {
      this.filter_option.distab.forEach((v) => {
        if (v.checked) {
          this.disId = v.id;
        }
      });
      this.filter_option.job.forEach((v) => {
        if (v.checked) {
          this.docpos = v.name;
        }
      });
      this.filter_option.service.forEach((v) => {
        if (v.checked) {
          this.docservice = v.id;
        }
      });

      http
        .post("/api/wap/doctor/indexlist", {
          pageIndex: this.page,
          diseasid: this.disId,
          position: this.docpos,
          service: this.docservice,
        })
        .then((res) => {
          done();
          res.data.forEach((v) => {
            v.label_list = [];
            if (v.label) {
              v.label_list = v.label.split(",");
            }
          });
          if (res.data.length < 10) {
            this.enableLoadMore = false;
          }
          if (this.page == 1) {
            this.doc_list = res.data;
          } else {
            this.doc_list = this.doc_list.concat(res.data);
          }
          this.$store.dispatch("getFindDocList", this.doc_list);
        })
        .catch((error) => {
          done();
          console.log(error);
        });
    },
    // 路由跳转
    routePush(path) {
      this.$router.push(path);
    },
  },
};
</script>
<style scoped>
@import "find_doctor.css";
.search-box {
  /* margin: 0 auto 0.65rem; */
  padding: 0.65rem 0;
  box-sizing: border-box;
  height: auto;
}
.search-img {
  top: 1.25rem;
}
.search-box input::-webkit-input-placeholder {
  /* WebKit browsers */
  color: rgba(0, 0, 0, 0.25);
  font-size: 0.8rem;
  padding-left: 0.5rem;
}
.search-box input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: rgba(0, 0, 0, 0.25);
  font-size: 0.8rem;
  padding-left: 0.5rem;
}
.search-box input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: rgba(0, 0, 0, 0.25);
  font-size: 0.8rem;
  padding-left: 0.5rem;
}
.search-box input:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: rgba(0, 0, 0, 0.25);
  font-size: 0.8rem;
  padding-left: 0.5rem;
}
.doc-mask{
  width: 100%;
  height: calc(100vh - 6rem);
  background: rgba(0, 0, 0, 0.25);
  position: absolute;
  top: 2.5rem;
  left: 0;
  z-index: 99;
}
</style>



// WEBPACK FOOTER //
// src/pages/find_doctor/find_doctor.vue